import { render, staticRenderFns } from "./FamilyOrderDetail.vue?vue&type=template&id=7f59bf8c&scoped=true&"
import script from "./FamilyOrderDetail.vue?vue&type=script&lang=js&"
export * from "./FamilyOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./FamilyOrderDetail.vue?vue&type=style&index=0&id=7f59bf8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59bf8c",
  null
  
)

export default component.exports